import { A } from "@solidjs/router"
import { Component } from "solid-js"
import { Img } from "./universal/image";
import {  ContestWinner } from "../Types";
import { RawHtml } from "./raw-html";
import { slug } from "../library/common";
import { P } from "./p";

type Props = {
    item: ContestWinner;
    maxHeight: number;
    maxWidth: number;
}
export const Winner : Component<Props> = ({ item, maxHeight, maxWidth }) => {
    const award = item.Award;
    // const prize = item.Prizes.find(x => x.AwardId == award.Id);
    const artist = item.Artist;
    const artworkUrl = `/artwork/${slug(item.Title)}/${slug(artist)}/${item.Id}`;
    const artistUrl = `/artist/${slug(artist)}/${item.ContestEntrantId}`;
    return (
        <div class="winner">
            <div class="row">
                <div class="col-md-6">
                    <div class="pull-right" style={{ "background-color": item.PrimaryImage.DominantColourHexCode || "#333", "max-width": `${maxWidth}px` }}>
                        <A href={artworkUrl}>
                            <Img class="no-clicky-for-you" src={item.PrimaryImage.URL}
                                maxHeight={maxHeight} maxWidth={maxWidth}
                                naturalWidth={item.PrimaryImage.Width} naturalHeight={item.PrimaryImage.Height}
                                style={{ width: "100%", height: "auto;" }}
                                mode="max" />
                        </A>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="grid-item" style="width: 100%; max-width: none;">
                        <div class="didactic">
                            <div class="row">
                                <div class="col-md-12">
                                    {/* <Show when={!!prize}>
                                        <h3 class="purchase-price">
                                            ${prize!.PrizeAmount} Cash Award
                                        </h3>
                                    </Show> */}
                                    <h3 class="award">
                                        {award}
                                    </h3>
                                    <h1 style="font-size: 3em;">
                                        <A href={artistUrl}>{artist}</A>
                                    </h1>
                                    <h2>
                                        <A href={artworkUrl}>{item.Title}</A>
                                    </h2>
                                    <P when={item.Year}>{item.Year}</P>
                                    <P when={item.Medium}>{item.Medium}</P>
                                    <RawHtml value={item.Measurements} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}